// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPatchFileDto
 */
export interface IPatchFileDto {
    /**
     * 
     * @type {string}
     * @memberof IPatchFileDto
     */
    name: string;
}

/**
 * Check if a given object implements the IPatchFileDto interface.
 */
export function instanceOfIPatchFileDto(value: object): value is IPatchFileDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IPatchFileDtoFromJSON(json: any): IPatchFileDto {
    return IPatchFileDtoFromJSONTyped(json, false);
}

export function IPatchFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPatchFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function IPatchFileDtoToJSON(json: any): IPatchFileDto {
    return IPatchFileDtoToJSONTyped(json, false);
}

export function IPatchFileDtoToJSONTyped(value?: IPatchFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

